import Flagship, { FlagMetadata } from '@flagship.io/js-sdk';
import { GET_FLAG_CAST_ERROR, GET_METADATA_CAST_ERROR, noVisitorMessage } from './constants';
import { hasSameType, logInfo, logWarn, sprintf } from './utils';
export class Flag {
    constructor(defaultValue, key, flagsData) {
        if (!flagsData) {
            logWarn(Flagship.getConfig(), noVisitorMessage, 'GetFlag');
        }
        this.defaultValue = defaultValue;
        this.key = key;
        this.flag = flagsData === null || flagsData === void 0 ? void 0 : flagsData.get(key);
    }
    NotSameType() {
        var _a;
        return this.defaultValue !== null && this.defaultValue !== undefined && !hasSameType((_a = this.flag) === null || _a === void 0 ? void 0 : _a.value, this.defaultValue);
    }
    getValue() {
        if (!this.flag) {
            logWarn(Flagship.getConfig(), noVisitorMessage, 'getValue');
            return this.defaultValue;
        }
        if (this.NotSameType()) {
            logInfo(Flagship.getConfig(), sprintf(GET_FLAG_CAST_ERROR, this.key), 'getValue');
            return this.defaultValue;
        }
        return this.flag.value;
    }
    exists() {
        if (!this.flag) {
            logWarn(Flagship.getConfig(), noVisitorMessage, 'exists');
            return false;
        }
        return !!(this.flag.campaignId && this.flag.variationId && this.flag.variationGroupId);
    }
    userExposed() {
        if (!this.flag) {
            logWarn(Flagship.getConfig(), noVisitorMessage, 'userExposed');
        }
        return Promise.resolve();
    }
    get metadata() {
        const functionName = 'metadata';
        if (!this.flag) {
            logWarn(Flagship.getConfig(), noVisitorMessage, functionName);
            return FlagMetadata.Empty();
        }
        if (this.NotSameType()) {
            logInfo(Flagship.getConfig(), sprintf(GET_METADATA_CAST_ERROR, this.key), functionName);
            return FlagMetadata.Empty();
        }
        return new FlagMetadata({
            campaignId: this.flag.campaignId,
            variationGroupId: this.flag.variationGroupId,
            variationId: this.flag.variationId,
            isReference: !!this.flag.isReference,
            campaignType: this.flag.campaignType,
            slug: this.flag.slug
        });
    }
}
